// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--6-2!./whatsapp.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("3d7bd5d6", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/css/whatsapp.css
// module id = 571
// module chunks = 9